export enum NumberPadConstants {
  NUMBER = 'Number',
  BACKSPACE = 'Backspace',
  EMPTY = 'EMPTY',
}
